/* global __CONFIG__: true */

export default __CONFIG__
